import React from 'react';
import { Link } from 'react-router-dom';
import HeroImg from "../../Pages/images/latest/HeroBanner.png";
import FrameImg from "../../Pages/images/latest/Frame 300.png";
import "./HomeHeroSection.css";

const HomeHeroSection = () => {
  return (
    <div className="home-hero-wrapper">
      {/* SECTION 1: Hero Banner */}
      <div
        className="hero-banner-section"
        style={{ backgroundImage: `url(${HeroImg})` }}
      >
        <div className="hero-banner-overlay"></div>
        <div className="hero-banner-container">
          <div className="hero-banner-left">
            <div className="hero-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="me-2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
              OUR BUSINESS MODEL
            </div>

            <h1 className="hero-title">
              OWN A CONTAINER.<br />
              WE RENT IT. <span className="highlight">YOU</span><br />
              <span className="highlight">EARN.</span>
            </h1>

            <p className="hero-description">
              Purchase a shipping container, hand it to us. Brooks Container leases it to global trade networks on behalf of you and shares monthly returns.
            </p>

            <div className="hero-buttons-container">
              <Link
                to="/contact-us"
                className="hero-card-btn orange-card"
                onClick={(e) => {
                  e.preventDefault();
                  window.dispatchEvent(new CustomEvent("openBookingModal"));
                }}
              >
                <div className="hero-card-icon-box">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div className="hero-card-text">
                  <span className="hero-card-title">SCHEDULE A MEETING WITH US</span>
                  <span className="hero-card-subtext">Speak with our experts and get started</span>
                </div>
              </Link>

              <Link to="/contact-us" className="hero-card-btn white-card">
                <div className="hero-card-icon-box">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                  </svg>
                </div>
                <div className="hero-card-text">
                  <span className="hero-card-title">KNOW YOUR PROFIT PLAN</span>
                  <span className="hero-card-subtext">See your potential returns</span>
                </div>
              </Link>
            </div>
          </div>

          <div className="hero-banner-right"></div>
        </div>
      </div>

      {/* SECTION 2: Price Details Section */}
      <div className="price-details-section">
        <div className="price-details-card">
          <div className="price-details-grid">

            {/* Left Column: Image */}
            <div className="price-details-image-box">
              <img src={FrameImg} alt="Container Price Details" className="price-details-img" />
            </div>

            {/* Right Column: Content */}
            <div className="price-details-content-box">
              <h2 className="price-details-title">Know Your Container Price Details</h2>
              <p className="price-details-subtitle">
                Get transparent pricing for the container size and type you need. Instant estimate. No hidden costs.
              </p>

              <div className="price-details-features-grid">

                {/* Feature 1 */}
                <div className="feature-item">
                  <div className="feature-icon-box">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="3" y1="9" x2="21" y2="9"></line>
                      <line x1="3" y1="15" x2="21" y2="15"></line>
                      <line x1="9" y1="3" x2="9" y2="21"></line>
                      <line x1="15" y1="3" x2="15" y2="21"></line>
                    </svg>
                  </div>
                  <h4 className="feature-title">All Sizes</h4>
                  <p className="feature-desc">20ft, 40ft & specialized containers</p>
                </div>

                {/* Feature 2 */}
                <div className="feature-item">
                  <div className="feature-icon-box">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                      <line x1="7" y1="7" x2="7.01" y2="7"></line>
                    </svg>
                  </div>
                  <h4 className="feature-title">Best Prices</h4>
                  <p className="feature-desc">Competitive pricing for every requirement</p>
                </div>

                {/* Feature 3 */}
                <div className="feature-item">
                  <div className="feature-icon-box">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                      <path d="m9 11 2 2 4-4"></path>
                    </svg>
                  </div>
                  <h4 className="feature-title">No Hidden Costs</h4>
                  <p className="feature-desc">100% transparent with complete cost breakdown</p>
                </div>

                {/* Feature 4 */}
                <div className="feature-item">
                  <div className="feature-icon-box">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </div>
                  <h4 className="feature-title">Instant Estimate</h4>
                  <p className="feature-desc">Get quick price insights in a few clicks</p>
                </div>

              </div>

              <div className="price-details-action">
                <Link to="/Productlist" className="price-action-btn">
                  KNOW YOUR CONTAINER PRICE
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" className="gradient-arrow ms-2">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHeroSection;